import { render } from "./TheDashboard.vue?vue&type=template&id=1dfee829"
import script from "./TheDashboard.vue?vue&type=script&lang=js"
export * from "./TheDashboard.vue?vue&type=script&lang=js"

import "./TheDashboard.vue?vue&type=style&index=0&id=1dfee829&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__